<div class="retributive-year-selector" [ngClass]="{ 'show-menu': showMenu }">
  <span class="year" (click)="openOptions($event)">
    {{ retributiveYear }}
    <bdr-icon class="icon" icon="caret-down" [esir]="true"></bdr-icon>
  </span>
</div>